module.exports = __webpack_public_path__ + "static/team-1-2-9c929325c469ce0ae4fef7388278c695.jpg";